export default "__VITE_ASSET__CM9c3Arh__"